export default [
  {
    uri: 'sync/readers',
    keyPath: 'externalId',
    objectStoreName: 'Readers',
    indexes: ['name', 'networkAddress', 'macAddress', 'status', 'lastModifiedTimestamp'],
  },
  {
    uri: 'sync/sites',
    keyPath: 'externalId',
    objectStoreName: 'Sites',
    indexes: ['name', 'status', 'lastModifiedTimestamp'],
  },
  {
    uri: 'sync/enterprises',
    keyPath: 'externalId',
    objectStoreName: 'Enterprises',
    indexes: ['name', 'status', 'lastModifiedTimestamp'],
  },
  {
    uri: 'sync/readzones',
    keyPath: 'externalId',
    objectStoreName: 'Readzones',
    indexes: ['lastModifiedTimestamp', 'status', 'name'],
  },
  {
    uri: 'sync/categories',
    keyPath: 'externalId',
    objectStoreName: 'Categories',
    indexes: ['lastModifiedTimestamp', 'status', 'name'],
  },
  {
    uri: 'sync/roles',
    keyPath: 'externalId',
    objectStoreName: 'Roles',
    indexes: ['lastModifiedTimestamp', 'name', 'status'],
  },
  {
    uri: 'sync/antennas',
    keyPath: 'internalId',
    objectStoreName: 'Antennas',
    indexes: ['name', 'port', 'enabled', 'reader', 'readZone', 'lastModifiedTimestamp', 'status'],
  },
  {
    uri: 'sync/app-insight-configs',
    keyPath: 'externalId',
    objectStoreName: 'AppInsightConfigs',
    indexes: [
      'metadata.name',
      'metadata.moduleName',
      'metadata.generatorClassName',
      'metadata.priority',
      'lastGenerationTimestamp',
      'nextGenerationTimestamp',
      'frequencyMillis',
      'lastModifiedTimestamp',
      'status',
    ],
  },
  {
    uri: 'sync/app-insights',
    keyPath: 'externalId',
    objectStoreName: 'AppInsights',
    indexes: ['config', 'value', 'insightTime', 'expiryTime', 'lastModifiedTimestamp', 'status'],
  },
  {
    uri: 'sync/tracked-items',
    keyPath: 'externalId',
    objectStoreName: 'Tracked Items',
    indexes: ['lastModifiedTimestamp', 'status', 'uri'],
  },
  {
    uri: 'sync/floors',
    keyPath: 'externalId',
    objectStoreName: 'Floors',
    indexes: ['lastModifiedTimestamp', 'status', 'uri'],
  },
  {
    objectStoreName: 'liveTest',
    keyPath: 'id',
    indexes: ['readerNetworkAddress', 'readzoneAlias', 'tag', 'antennaPort', 'count', 'first', 'last', 'uuid'],
  },
  {
    objectStoreName: 'liveTestResults',
    keyPath: 'id',
    indexes: [
      'readerNetworkAddress',
      'readzoneAlias',
      'tag',
      'antennaPort',
      'count',
      'startTime',
      'finishTime',
      'username',
      'userUuid',
      'type',
      'requestUuid',
      'readerUuid',
      'readerName',
      'tagPrefixes',
      'readerMacAddress',
      'readerIpAddress',
    ],
  },
]
